import React from 'react';
import './Sort.css';

const Caret = () => {    
  return( 
       <span className="caret" onKeyDown={(e)=>{ if (e.key === "Enter") {      
        e.stopPropagation();            
    }}}
     />
    )
}

export default Caret;